import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isOpen", "timeout", "className"];
import React from 'react';
import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { isUndefined } from 'lodash-es';
export var Collapse = function Collapse(props) {
  var isOpen = props.isOpen,
    timeout = props.timeout,
    className = props.className,
    htmlProps = _objectWithoutProperties(props, _excluded);
  var variants = {
    open: {
      height: 'auto',
      opacity: 1,
      transitionEnd: {
        overflow: 'initial'
      },
      transition: {
        opacity: {
          delay: .15
        }
      }
    },
    closed: {
      height: 0,
      opacity: 0,
      overflow: 'hidden'
    }
  };
  var classNames = cn('collapse', className);
  return React.createElement(AnimatePresence, {
    initial: false
  }, isOpen && React.createElement(motion.div, _extends({
    key: "content"
  }, htmlProps, {
    className: classNames,
    variants: variants,
    initial: 'closed',
    animate: 'open',
    exit: 'closed',
    transition: {
      type: 'spring',
      bounce: 0,
      duration: isUndefined(props.timeout) ? undefined : props.timeout === 0 ? props.timeout : props.timeout / 1000
    }
  }), props.children));
};
Collapse.defaultProps = {
  isOpen: false
};